


export const FINANCIAL_AID_DETAILS = "FINANCIAL_AID_DETAILS";
export const FINANCIAL_AID_DETAILS_SUCCESS = "FINANCIAL_AID_DETAILS_SUCCESS";
export const FINANCIAL_AID_DETAILS_FAIL = "FINANCIAL_AID_DETAILS_FAIL";


export const GET_FA_APT_DETAILS = "GET_FA_APT_DETAILS";
export const GET_FA_APT_DETAILS_SUCCESS = "GET_FA_APT_DETAILS_SUCCESS";
export const GET_FA_APT_DETAILS_FAIL = "GET_FA_APT_DETAILS_FAIL";


export const GET_ALL_DONATIONS = "GET_ALL_DONATIONS";
export const GET_ALL_DONATIONS_SUCCESS = "GET_ALL_DONATIONS_SUCCESS";
export const GET_ALL_DONATIONS_FAIL = "GET_ALL_DONATIONS_FAIL";


export const DONATION_TOTAL = "DONATION_TOTAL";
export const DONATION_TOTAL_SUCCESS = "DONATION_TOTAL_SUCCESS";
export const DONATION_TOTAL_FAIL = "DONATION_TOTAL_FAIL";



export const GET_APPROVED_FINANCIAL_AID = "GET_APPROVED_FINANCIAL_AID";
export const GET_APPROVED_FINANCIAL_AID_SUCCESS = "GET_APPROVED_FINANCIAL_AID_SUCCESS";
export const GET_APPROVED_FINANCIAL_AID_FAIL = "GET_APPROVED_FINANCIAL_AID_FAIL";
